import Divider from '@components/Divider/Divider';
import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import {
  SequentialBlock as SequentialBlockProps,
  SequentialBlockTypes,
} from '@features/api/response/tabContent/common/SequentialBlock';
import { CircularProgress, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { useState } from 'react';
import { StyledImage } from './SequentialBlock.styles';

const BULLET_UNICODE = '\u2B24';

const SequentialBlock: React.FC<SequentialBlockProps> = ({
  sequenceNumber,
  type,
  value,
}) => {
  const theme = useTheme();

  const [hasImageLoaded, setHasImageLoaded] = useState(false);

  return (
    <>
      {type === SequentialBlockTypes.IMAGE && !hasImageLoaded ? (
        <Flex width='100%' alignItems='center' justifyContent='center'>
          <CircularProgress color='primary' size={60} />
        </Flex>
      ) : null}
      <Flex
        flexDirection='column'
        gap={4}
        sx={{
          maxHeight: 500,
          height: 'auto',
          width:
            type !== SequentialBlockTypes.IMAGE || hasImageLoaded ? '100%' : 0,
        }}
      >
        {type !== SequentialBlockTypes.IMAGE &&
          type !== SequentialBlockTypes.LIST_ITEM &&
          value &&
          value.split('\n').map((s) => (
            <Text
              key={s}
              variant={
                type === SequentialBlockTypes.DESCRIPTION ? 'body' : 'h6'
              }
              fontWeight={
                type === SequentialBlockTypes.DESCRIPTION
                  ? 'fontWeightRegular'
                  : 'fontWeightMedium'
              }
              color={
                type === SequentialBlockTypes.HEADER
                  ? theme.palette.primary.main
                  : theme.palette.black[500]
              }
            >
              {s}
            </Text>
          ))}
        {type === SequentialBlockTypes.IMAGE ? (
          <StyledImage
            data-testid={`sequential-block-image-${sequenceNumber}`}
            data={value}
            onLoad={() => setHasImageLoaded(true)}
          />
        ) : null}
        {type === SequentialBlockTypes.SEPARATOR ? (
          <Box my={14}>
            <Divider />
          </Box>
        ) : null}
        {type === SequentialBlockTypes.LIST_ITEM ? (
          <Flex gap={4} alignItems='flex-start'>
            <Text
              variant='bodySmall'
              fontWeight='fontWeightRegular'
              color={theme.palette.black[500]}
              sx={{ fontSize: 4, marginTop: theme.spacing(5) }}
            >
              {BULLET_UNICODE}
            </Text>
            <Text
              variant='bodyBig'
              fontWeight='fontWeightRegular'
              color={theme.palette.black[500]}
            >
              {value}
            </Text>
          </Flex>
        ) : null}
      </Flex>
    </>
  );
};

export default SequentialBlock;
